<template>
    <div style="padding:20px;background:#eeeeee">

        <h1>Weaver Terms of Service</h1>

<br/>Welcome to Weaver by Splashweave Pty Ltd
<br/>
<br/>These terms govern the use of the Weaver set of products, including but not limited to the following:
<ul>
<li>Weaver iOS mobile application</li>
<li>Weaver Android mobile application</li>
<li>Weaver website</li>
<li>Weaver web applications</li>
<li>Weaver cloud based backend services</li>
</ul>
<br/>This aforementioned definition of the Weaver product set will be henceforth referred to as Weaver. Splashweave Pty Ltd will henceforth be referred to as Splashweave.
<br/><br/>
<h2>About Weaver</h2>
Welcome to Weaver.
<br/>Weaver is a communication social platform that allows users to be able to communicate with each other without many of the barriers other platforms impose. From the anonymous sign in to non-unique usernames we at Splashweave have really tried to avoid the distractions found in other social platforms.
<br/>We designed Weaver to be all about being in the moment with transient messages in public channels. If you leave a channel and come back you don’t have to go through a wall of historical messages, it’s right back to communicating with other users.
<br/>Whether it is work or play we hope that you enjoy using Weaver as much as we did creating it but there are a few things you should be aware of before continuing.
<br/>
<br/><h2>Who Can Use Weaver</h2>
We want to make Weaver accessible to as many people as possible but there are some important restrictions in who can use weaver. Here is the list of who we cannot allow to use weaver:
<ul>
<li>Anyone under the age of 13 (or the minimum legal limit for social media in your country, whichever is higher)</li>
<li>We have previously banned you for violation of these Terms of Service</li>
<li>You are prohibited from receiving or using our products under applicable laws</li>
</ul>
<br/>These restrictions are critical in ensuring Weaver remains an enjoyable platform for all valid users.
<br/>
<br/><h2>Advertising</h2>
There is none. No banner ads. No full screen popup ads. We also reserve the right to remove your messages if they are ads and they are not in a channel where ads are expected. 
<br/>
<br/>So to make things simple:
<br/>DOs 
<ul>
<li>Enjoy the ad free experience</li>
<li>Create a public channel for Atlantis buy sell swap and peddle your 96 Honda Civic there</li>
</ul>
<br/>DONTs
<ul>
<li>Advertise the latest multi level marketing product pyramid scheme in the global channel… or really any channel that’s not clearly listed as selling stuff. You will get reported and you will get banned</li>
</ul>
<br/>
<br/><h2>Selling your Data</h2>
Splashweave will never sell your identifiable information to anyone. What we reserve the right to do is to offer insights to companies about a product or service they have by providing metadata analysis. Things like keyword search with an analytic engine detecting if you are saying positive things about their product and we will only do that providing we have a large enough sample size of distinct users so there’s no possible way that insight can be used to identify someone in the real world.
<br/>
<br/>So to make things simple here’s our list:
<br/>DOs
<ul>
<li>Provide Mitsubishi with some analysis stating their Air Conditioners are being positively mentioned over the summer months</li>
</ul>
<br/>DONTs
<ul>
<li>Provide Honda information that there is one person trying to sell their 96 Honda Civic in Atlantis</li>
<li>Never ever sell to a certain Nigerian prince a list of names and emails</li>
</ul>
<br/>
<br/><h2>Funding for Services</h2>
We have to do something to keep the lights on and the cost of running a system capable of millions of messages a second is even more than daily smashed avo from that corner cafe. We have already mentioned no advertising so instead we offer In App Purchases (IAP). We use IAP to allow people purchase Rank Points which are used to unlock more perks when using Weaver. The great part is (if you are a freeloader), they are entirely optional. Rank Points are earned just by using the app but if you want to help support Weaver and save a bit of time then we provide packages at a variety of price points.
<br/>
<br/>In addition to IAPs we also reserve the right to sell de-identified data meta analysis for trends and analysis. If you want to know more look back over the Selling your Data section above.
<br/>
<br/>Finally we can also provide Weaver as a basis for any other reliable communication platform so if you have a commercial product that needs a reliable, performant communication platform we can create a private Weaver channel set for use for a small fee. To find out more about this please email contact@splashweave.com    
<br/>
<br/>As a further point to the commercial usage of Weaver we explicitly prohibit using Weaver for your own product without a license.
<br/>
<br/>In summary:
<br/>DOs
<ul>
<li>Purchase In App Purchases if you want to help support Weaver</li>
<li>Let us know if you want to use Splashweave for commercial purposes</li>
<li>Shout the Splashweave team smashed avo every once in a while</li>
</ul>
<br/>DONTs
<ul>
<li>Just wrap up the Weaver client into your own commercial application without paying for a license. Not cool</li>
</ul>
<br/>
<br/><h2>Public vs Private Communication</h2>
In addition to being able to create as many Public Channels as you want (seriously, go nuts) Weaver allows you to create Private Channels as well as direct messaging via Inboxing. We are Splashweave just want to stress that all communication should be treated like public communication, even from within Private Channels. Think of Private Channels like your own personal nightclub and it’s invite only but the bouncer isn’t that great and is on their phone way more often than they should be.
<br/>
<br/>Treat it all like public information and just enjoy yourself.
<br/>
<br/>In summary:
<br/>DOs
<ul>
<li>Create heaps of Public Channels</li>
<li>Create private channels and invite as many people as you want</li>
<li>Treat all communication as public</li>
</ul>
<br/>DONTs
<ul>
<li>Talk about top secret national intelligence</li>
<li>Hire Geoff the bouncer again</li>
</ul>
<br/>
<br/><h2>Community Guidelines</h2>
Nobody likes a toxic community and here at Weaver we want everyone to be able to enjoy themselves. In order to achieve this there’s an onus on everyone to act like a decent human being. I know this is a big ask for some people so let’s spell out some of the things you really shouldn’t be talking about or posting links about (in case it’s not obvious):
<ul>
<li>Serious threats of violence towards any individual or group, human or otherwise. </li>
<li>Talking about association or membership with any organisation or group who are clearly known for violence, hate or illegal activities.</li>
<li>Praising or speaking in a positive way about any group or organisation that fits into the previous restriction.</li>
<li>Amassing or organising any group for the purpose of being violent, spreading hate or other illegal activities.</li>
<li>Attempting to sell, purchase, exchange, giveaway any goods or services that we deem unethical or violate either the legal restrictions of Australia and/or your local legal restrictions. This list includes but it not limited to: Firearms, ammunition, drugs (illicit, recreational, non-medical or pharmaceutical), prositution, human trafficking, organs (human or not), stolen goods.</li>
<li>Anything that is deemed fraudulent or a scam. Things like trying to deceive someone or a group of people for your own personal gain (not just monetary).</li>
<li>Bullying and/or harassment of any individual or group.</li>
<li>Posting any content without the rightful owners permission and consent. Particularly content of a sensitive nature. This includes any content where you do not own the intellectual property rights.</li>
<li>Hate speech of any variety (race, sex, occupation, sexual orientation, gender, disability, religion etc.).</li>
<li>Graphic Violent content (e.g. gore).</li>
<li>Inappropriate nudity or sexual content including anything to do with anyone under the age of 18 or the appropriate local legal limit whichever is higher.</li>
<li>Spam messages or links.</li>
<li>Personal information which could be used to identify someone in the real world.</li>
<li>Anything else we are Weaver deem to be unacceptable.</li>
</ul>
<br/>It is important to note that we at Splashweave are the ultimate deciders of what constitutes a breach of these restrictions. In the event of a breech we may deem a course of action which we feel is appropriate to the situation. However it is equally important to note that Weaver utilizes public and private moderators to moderate it’s content and that these individuals are humans who will have their own interpretations of what constitutes a breach. If you are unhappy with the moderation decision of one of the public or private moderators you may contact the Splashweave team either in app using the channel weaver://moderatorreports or by emailing contact@splashweave.com.
<br/>In summary:
<br/>DOs
<ul>
<li>Follow all of the above guidelines</li>
<li>At least act like a decent human being</li>
</ul>
<br/>DONTs
<ul>
<li>Be a dick</li>
<li>Get angry at the moderation team for trying to keep the community decent. Use the channel provided (or email if you are banned) to contest a decision</li>
</ul>
<br/>
<br/><h2>Permissions to use your content</h2>
At Splashweave we understand some of the content you provide to Weaver will be protected by intellectual property laws. As stated in the community guidelines, you must only post content in which you have the legal right to use. It is important to note that any content in which you own the intellectual property rights will remain as your own if you post it to Weaver. However as all content posted to Weaver is stored and shared to other members of the platform we require you to give us the legal permission to use this content. This is given in the form of a non-exclusive, transferable, sub-licensable, royalty-free and worldwide license to host, use, distribute, modify, run, copy, publicly perform or display, translate, and create derivative works of your content. Please see the Data Policy for information regarding storage and deletion of content including content where you own the intellectual property.
<br/>
<br/>In summary
<br/>DOs
<ul>
<li>Only post content matching community guidelines that you own the intellectual property rights with the understanding that you provide the content with license to use the content as per the provisions above.</li>
<li>Share original content with the knowledge that you are not giving up your rights by doing so. We at Splashweave are not going to take your song lyrics and use them to make our own worldwide smash hit.</li>
</ul>
<br/>DONTs
<ul>
<li>Post something which you do not own the intellectual rights</li>
<li>Expect the granted license to be revoked as soon as the content is no longer visible to you</li>
</ul>
<br/>
<br/><h2>Limits on our Intellectual Property</h2>
We at Splashweave own the intellectual property rights to all Splashweave assets and trademarks and Weaver assets and trademarks including the Weaver and Splashweave names, icons, graphics and general design. You may only use our assets and trademarks with our express prior written permission. There as some exceptions to this condition however and that is for the following purposes:
<ul>
<li>Reviews and editorials</li>
<li>News articles and news programming</li>
<li>Talk shows.</li>
</ul>
<br/>If you wish to obtain permission for other uses please contact contact@splashweave.com
<br/>
<br/><h2>Limits on liability</h2>
Our products are provided “as is” and we make no guarantees that they always will be safe, secure, error-free, or that they will function without disruptions, delays or imperfections. To the extent permitted by law, we also DISCLAIM ALL WARRANTIES, WHETHER EXPRESS OR IMPLIED, INCLUDING THE IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
<br/>
<br/>We at Splashweave cannot control the actions or conduct of the users that use our software (whether human or not) and we are not responsible for their actions or conduct including any content they share (including offensive, immoral or illegal content). We at Splashweave are not condoning or forming any representation of any actions, conduct or content produced by the users of Weaver through implicit or explicit action or inaction by Splashweave.
<br/>
<br/>We cannot predict when issues might arise with our Products. Accordingly, our liability shall be limited to the fullest extent permitted by applicable law, and under no circumstance will we be liable to you for any lost profits, revenues, information, or data, or consequential, special, indirect, exemplary, punitive, or incidental damages arising out of or related to these Terms or the use of Weaver, even if we have been advised of the possibility of such damages.
<br/>
<br/><h2>Other Important Information</h2>
<ul>
<li>If you download the Weaver software you grant us permission to install updated to your devices when updates are available.</li>
<li>Splashweave reserves the right to deny access to the platform if you attempt to use an old version of the Weaver software to access Weaver.</li>
<li>Splashweave reserves the right to update the minimum requirements to run Weaver and thus may result in you being unable to access Weaver.</li>
<li>Splashweave reserves the right to change these Terms of Service at any time. If the Terms of Service does change then it will be updated with a new version of Weaver which will require acceptance of these changes. Where possible Splashweave will give you the opportunity to review changes to the Terms of Service before it is enforced. If you no longer agree to the updated policy you can discontinue use of Weaver.</li>
<li>These Terms of Service together with the Data Policy form the entire agreement between you and Splashweave Pty Ltd regarding the use of Weaver. These terms supersede any prior agreements.</li>
<li>If any portion of these Terms is found to be unenforceable, the remaining portion will remain in full force and effect. If we fail to enforce any of these Terms, it will not be considered a waiver. Any amendment to or waiver of these Terms must be made in writing and signed by us.</li>
<li>References to Mitsubishi, Honda, Nigerian princes and Bouncers named Geoff do not indicate any association with these entities, these references were purely used for humour purposes as comical examples</li>
<li>You will not transfer any of your rights or obligations under these Terms to anyone else without our consent.</li>
<li>We reserve all rights not expressly granted to you</li>
</ul>
<br/>
<br/>
<br/><h1>Data Policy</h1>
<br/>
<br/><h2>The information we collect</h2>
Splashweave collects the content, communications and other information you provide when you use Weaver, including when you sign up for an account, create or share content, and message or communicate with others.
<br/>
<br/><h3>Firebase and Google Platform usage</h3>
Weaver uses a number of components from the Firebase and Google Cloud platforms namely:
<ul>
<li>Firebase Authentication</li>
<li>Firebase Hosting</li>
<li>Firebase Cloud Hosting</li>
<li>Google Cloud Hosting</li>
</ul>
<br/>By agreeing to these terms and conditions you also agree to the Google partners terms and conditions located here: 
<br/><a href="https://policies.google.com/technologies/partner-sites">“How Google uses data when you use our partners’ sites or apps” </a>
<br/>https://policies.google.com/technologies/partner-sites
<br/>
<br/><h2>Specific Information Usage</h2>
<br/>
<br/><h3>Identity Information</h3>
Weaver stores the following Identity Information:
<ul>
<li>First and Last Name</li>
<li>Email Address</li>
<li>Password</li>
</ul>
<br/>This information is collected and stored using Firebase Authentication. A unique Id is generated to represent you as a user of weaver and is associated with your account. This unique identifier is also stored on local device storage. All other storage within Weaver excluding Firebase authentication storage will use this unique Id in conjunction with device Ids to identify you throughout Weaver. 
<br/>
<br/>How do we use this information?
<br/>Identify information excluding your Unique Id is used by Splashweave within Weaver for account recovery purposes. As Firebase is a third party identity provider please also see their data use policy located here:
<br/><a href="https://policies.google.com/technologies/partner-sites">“How Google uses data when you use our partners’ sites or apps” </a>
<br/>https://policies.google.com/technologies/partner-sites
<br/>
<br/>Your unique user identifier is used within Weaver to facilitate persistent functionality including but not limited to channel membership, rank accumulation, inboxing, moderation and perk regulation. Your unique identifier may be accessed as a part of a diagnostic procedure or where required by law.
<br/>
<br/>Your unique identifier will not be sold for commercial use or used for targeted advertising. 
<br/>
<br/><h3>Device Information</h3>
Splashweave collects the device id from each of the devices you use when accessing Weaver. These device ids are stored together with your unique Id generated during the sign up process. In addition to accessing device ids Weaver also stores data on your device in the form of cookies. 
<br/>
<br/>How do we use this information?
<br/>Weaver uses device identifiers as a way to restrict access in the case of a breach of these Terms of Service. 
<br/>
<br/><h3>Cookies information</h3>
Cookies are small pieces of text stored on your devices to facilitate the saving of state between different Weaver sessions. The cookies used within Weaver store the following information:
<ul>
<li>The list of channels you currently have open
<ul>
<li>Weaver does this to allow the application to reopen the same set of channels after restarting the application.</li>
</ul></li>
<li>A device based unique user identifier
<ul>
<li>Weaver does this to ensure we have a persistent user identifier to maintain persistence across multiple login sessions.</li>
</ul></li>
<li>Silence duration
<ul>
<li>In the event your account is temporarily silence due to message frequency Weaver stores your remaining silence time on local storage to ensure the silence persists across application restarts.</li>
</ul></li>
<li>Displayed Help State
<ul>
<li>Weaver stores a flag as to whether you have seen the help popup as to avoid displaying the help page after every application restart.</li>
</ul></li>
</ul>
<br/>
<br/>Cookies are not used in conjunction with any form of monetisation or advertising purposes. 
<br/>These cookies can be removed from the device at any time and Weaver will create new ones at the next application restart.  
<br/>
<br/><h3>Content and Communication</h3>
All content you provide while using Weaver is stored including but not limited to:
<ul>
<li>User Names</li>
<li>Message Contents</li>
<li>Inbox messages both sent and received</li>
<li>Background Images</li>
<li>Pinned Messages</li>
</ul>
<br/>This content is stored even after the information is no longer accessible through the Weaver Web and Mobile applications.
<br/>
<br/>All content and communication provided during the use of Weaver should be assumed to be publicly accessible even if the function itself indicates a degree of privacy for example Private Channels
<br/>
<br/>How do we use this information?
<br/>This information is used in a number of ways as detailed below:
<br/>
<br/><u>Operation of Weaver and sharing content between users.</u>
<br/>To ensure Weaver is able to share content between users some information must be stored. A simple example of this is background images. Weaver must store the background image of a particular private channel to be able to distribute it to you and other members of the private channel.
<br/>
<br/><u>Diagnostic Information.</u>
<br/>Splashweave reserves the right to store and access your content and communication including unique identifiers provided through Weaver to facilitate diagnostic operations, bug fixes, enhancements and improvements to the platform.   
<br/>
<br/><u>Legal Retention and Access.</u>
<br/>Splashweave retains your content and communication provided through Weaver as per local law enforcement requirements and reserves the right to release this information together with any personal identification to any lawful body as per local legislation.
<br/>
<br/><u>Metadata Analysis Including Commercial Purposes.</u>
<br/>Splashweave reserves the right to use de-identified content and communications provided through Weaver for the purposes of providing external companies and organisations insights into products and services including for commercial purposes.
<br/>
<br/><h2>How can I Manage or Delete the Information about me?</h2>
At any point you are entitled to send a request to access or delete the personal information associated with your account. To send this request please email contact@splashweave.com with the title “Personal Information Data Access Request”. Please allow for up to 10 business days to action this request. Please note exclusionary waiting periods may apply when requesting personal information be removed as per legal requirements or if the information is required to facilitate the operation of Weaver. An example of operational restrictions to deleting personal information would be a custom image background for a private channel still in use. In that example the background image would need to be changed first and then once it was no longer the current background it could then be safely removed from the system after legal retention periods no longer applied.   
<br/> 
<br/><h2>Changes to the Data Policy</h2>
Splashweave reserves the right to change this Data Policy at any time. If the data policy does change then it will be updated with a new version of Weaver which will require acceptance of these changes. Where possible Splashweave will give you the opportunity to review changes to the Data Policy before it is enforced. If you no longer agree to the updated policy you can discontinue use of Weaver.
<br/>
<br/><h2>How do I contact Splashweave with questions surrounding this Data Policy?</h2>
If you have any questions in regards to this Data Policy or the Terms of Use feel free to contact Splashweave either via email at contact@splashweave.com or by mail at the address below:
<br/>PO Box 6602
<br/>Upper Mount Gravatt
<br/>Queensland
<br/>Australia
<br/>4122
    </div>
</template>

<script>

export default {
  name: "terms",
};
</script>
